import React, { createContext, useContext, useEffect, useState } from 'react';
import { soundManager, SOUNDS, type SoundName } from '../utils/soundManager';

interface SoundContextType {
  playSound: (name: SoundName, volume?: number) => void;
  isMuted: boolean;
  toggleMute: () => void;
}

const SoundContext = createContext<SoundContextType | undefined>(undefined);

export const SoundProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMuted, setIsMuted] = useState(soundManager.isMuted());

  useEffect(() => {
    // Initialize sound manager when component mounts
    soundManager.init();
  }, []);

  const playSound = (name: SoundName, volume: number = 1.0) => {
    soundManager.play(name, volume).catch(error => {
      console.error(`Failed to play sound ${name}:`, error);
    });
  };

  const toggleMute = () => {
    const newMutedState = soundManager.toggleMute();
    setIsMuted(newMutedState);
  };

  return (
    <SoundContext.Provider value={{ playSound, isMuted, toggleMute }}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSound = () => {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSound must be used within a SoundProvider');
  }
  return context;
};